import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { selectOrders } from './ordersSlice';
import OrderObj from './orderObj';
import ChangeDeliveryDate from './ChangeDeliveryDate';
import OrderAgainButton from './OrderAgainButton';
import RefundOrder from './RefundOrder';

export default function MyOrdersMobile() {
  const orders: Array<Record<string, any>> = useSelector(selectOrders);

  return (
    <div className='my-orders-mobile my-5'>
      {orders.length <= 0
        ? <Card body className='my-1'>
          <Row className='my-1'>
            <Col xs={6} className='fw-bold'>Order</Col>
            <Col xs={6}>
              ---
            </Col>
          </Row>
          <Row className='my-1'>
            <Col xs={6} className='fw-bold'>Date</Col>
            <Col xs={6}>
              ---
            </Col>
          </Row>
          <Row className='my-1'>
            <Col xs={6} className='fw-bold'>Status</Col>
            <Col xs={6}>---</Col>
          </Row>
          <Row className='my-1'>
            <Col xs={6} className='fw-bold'>Delivery Date</Col>
            <Col xs={6}>---</Col>
          </Row>
          <Row className='my-1'>
            <Col xs={6} className='fw-bold'>Total</Col>
            <Col xs={6}>
              ---
            </Col>
          </Row>
          <Row className='my-1'>
            <Col xs={6} className='my-1 fw-bold'>Actions</Col>
            <Col xs={6} className='vstack gap-1'>
              <Button
                as={Link as any}
                to={'/order'}
                variant="link"
                className='text-start text-black p-0'
              >Order</Button>
            </Col>
          </Row>
        </Card>
        : <>
          {orders.map((orderData) => {
            const order = new OrderObj(orderData);
            return (
              <Card body className='my-1' key={order.data.id}>
                <Row className='my-1'>
                  <Col xs={6} className='fw-bold'>Order</Col>
                  <Col xs={6}>
                    <Button
                      as={Link as any}
                      to={'/my-account/orders/' + order.data.id}
                      variant="link"
                      order={order}
                      className='text-black p-0'
                    >#{order.data.id}</Button>
                  </Col>
                </Row>
                <Row className='my-1'>
                  <Col xs={6} className='fw-bold'>Date</Col>
                  <Col xs={6}>
                    {order.getDate()}
                  </Col>
                </Row>
                <Row className='my-1'>
                  <Col xs={6} className='fw-bold'>Status</Col>
                  <Col xs={6}>{order.data.status}</Col>
                </Row>
                <Row className='my-1'>
                  <Col xs={6} className='fw-bold'>Delivery Date</Col>
                  <Col xs={6}>{order.getDeliveryDate()}</Col>
                </Row>
                <Row className='my-1'>
                  <Col xs={6} className='fw-bold'>Total</Col>
                  <Col xs={6}>
                    <span className='fw-bold'>${order.data.total}</span> for&nbsp;
                    {order.getTotalItems()} items
                  </Col>
                </Row>
                <Row className='my-1'>
                  <Col xs={6} className='my-1 fw-bold'>Actions</Col>
                  <Col xs={6} className='vstack gap-1'>
                    <OrderAgainButton order={order} />
                    {order.isModifiable() && <ChangeDeliveryDate order={order} />}
                    {order.isRefundable() && <RefundOrder order={order} />}
                  </Col>
                </Row>
              </Card>

            )
          })}
        </>}
    </div>
  );
}